import React from "react";
import { Row, Card, CardBody, Container } from "reactstrap";

import banner from "../assets/images/banner-amar.jpg";

export default function SectionAmarBank() {
    return (
        <section id="banner" style={{ paddingTop: '40px' }}>
            <Container>
                <Row>
                    <Card className="border-0 rounded">
                        <CardBody className="p-0 text-center">
                            <a
                                href="https://embedded-landing-widget.amarbank.co.id/?client_id=ebf-nadi-web"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={banner}
                                    className="img-fluid"
                                    alt="bannerImage"
                                    style={{ cursor: "pointer", borderRadius: "8px", width: "100%" }}
                                />
                            </a>
                        </CardBody>
                    </Card>
                </Row>
            </Container>
        </section>
    );
}
